import $ from 'jquery'
import menuAim from 'jquery-menu-aim'
import itemTemplate from 'templates/navigation/item.pug'

import BaseComponent from 'scripts/components/base-component'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'

class NavigationMenu extends BaseComponent {
  static componentName = 'navigation-menu'

  static DOMEvents = {
    'click [data-navigation="mobile"]': 'onMenuClick'
  }

  init () {
    this.$container = $('.navigation-overlay')
    this.$content = this.$container.find('.navigation-menu-content')
    this.baseDomain = this.$element.data('base-domain')
    this.endpoint = `${this.baseDomain}/category_childs/`
    this.items = {}
    this.cacheItem = this.cacheItem.bind(this)
    this.renderIfCurrent = this.renderIfCurrent.bind(this)

    this.$element.menuAim({
      activate: this.onMenuHover.bind(this),
      rowSelector: '[data-navigation-id]'
    })
  }

  onMenuHover (row) {
    this.$element.addClass('item-active')
    this.setActiveItem(row)
    this.loadItem(this.getItemID(row))
  }

  onMenuClick (e) {
    this.$element.addClass('item-active')
    this.setActiveItem(e.target)
    this.loadItem(this.getItemID(e.target))
  }

  setActiveItem (item) {
    const $item = this.getItem(item)
    this.$element.find('.navigation-menu-item.active').removeClass('active')
    $item.addClass('active')
  }

  loadItem (id) {
    this.$content.html('')

    this.$container.addClass('visible')
    showSpinner()

    if (this.items[id]) {
      return this.renderItem(this.items[id])
    }

    this.currentID = id

    $.get(this.endpoint + id)
      .done(this.cacheItem(id))
      .done(this.renderIfCurrent(id))
  }

  renderItem (data) {
    hideSpinner()
    this.$content.html(itemTemplate(data))
  }

  renderIfCurrent (id) {
    return (data) => {
      if (id === this.currentID) {
        this.renderItem(data)
      }
    }
  }

  cacheItem (id) {
    return (data) => {
      this.items[id] = data
    }
  }

  getItemID (item) {
    return this.getItem(item).attr('data-navigation-id')
  }

  getItem (item) {
    const $item = $(item)
    return $item.attr('data-navigation-id') ? $item : $item.closest('[data-navigation-id]')
  }
}

export default ($el) => new NavigationMenu($el).init()

export { NavigationMenu as Component }
